import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';
import { useHistory, useParams } from 'react-router-dom';
import { IonContent } from '@ionic/react';
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import PageWithBackButton from '../components/generic/PageWithBackButton';
import Post from '../components/Post';
import Footer from '../components/Footer';
import { useAuthContext } from '../providers/auth-provider';
import { feedSelector, updateFeedFilters } from '../redux/slices/feed';

const PostPage = () => {
  const { id } = useParams();
  const { user } = useAuthContext();
  const [post, setPost] = useState(null);
  const { get, response } = useFetch();
  const history = useHistory();
  const dispatch = useDispatch();
  const { feedFilters } = useSelector(feedSelector);

  useEffect(() => {
    let isMounted = true;

    const fetchPost = async () => {
      if (user) {
        const data = await get(`/posts/${id}`);
        if (!isMounted) return;

        if (response.ok) {
          setPost(data);
        } else {
          toast(
            'Post not found',
            { duration: 2500 },
          );
          history.push('/tabs/feed');
        }
      }
    };

    fetchPost();

    return () => {
      isMounted = false;
    };
  }, [user]);

  // if feedFilters is empty => if user enters app from notifications instead of feed
  const getFeedFilters = () => {
    const itemMeta = async () => {
      try {
        const filterData = await get('/user-feed/filters');
        if (filterData) {
          dispatch(updateFeedFilters(filterData));
        }
      } catch (error) {
        console.error('Error getting feed filters in post page: ', error);
      }
    };
    itemMeta();
  };

  useEffect(() => {
    if (user && post) {
      if (!feedFilters) {
        getFeedFilters();
      }
    }
  }, [user, post]);

  return (
    <PageWithBackButton backButtonText={post?.goal_id ? 'Goal' : 'Post'}>
      <IonContent>
        {post && feedFilters && <Post post={post} setPost={setPost} filterMeta={feedFilters} />}
      </IonContent>
      <Footer />
    </PageWithBackButton>
  );
};

export default PostPage;
